// extracted by mini-css-extract-plugin
export default {"otherCardsWrapper":"styles_otherCardsWrapper__Q8Ohl"};